import { MessageDirection } from 'src/api/generated';
import type {
  TimelineMessageActivity,
  TimelineMessageActivityParams,
} from '../../types/timeline/new-message-activity.types';
import { isMessageItem } from './item-type-guards.util';
import { getActivityTimestamp } from './activity-timestamp.util';

/** Counts new inbound identities; older pages and delivery-status updates do not increase it. */
export const advanceTimelineMessageActivity = (
  previous: TimelineMessageActivity | null,
  params: TimelineMessageActivityParams
): TimelineMessageActivity | null => {
  if (!params.ready) {
    return previous?.scopeKey === params.scopeKey ? previous : null;
  }
  const current = previous?.scopeKey === params.scopeKey ? previous : null;
  const messages = params.items
    .filter(isMessageItem)
    .filter((item) => item.direction === MessageDirection.INBOUND);
  let watermark = current?.watermark ?? -Infinity;
  let latestIds = new Set(current?.latestIds);
  let additions = 0;
  const observed = new Set<string>();
  for (const item of messages) {
    const time = getActivityTimestamp(item.createdAt)?.timestamp;
    if (time === undefined || observed.has(item.id)) continue;
    observed.add(item.id);
    if (
      current &&
      (time > current.watermark ||
        (time === current.watermark && !current.latestIds.has(item.id)))
    ) {
      additions += 1;
    }
    if (time > watermark) {
      watermark = time;
      latestIds = new Set([item.id]);
    } else if (time === watermark) {
      latestIds.add(item.id);
    }
  }
  return {
    scopeKey: params.scopeKey,
    watermark,
    latestIds,
    count: params.isAtBottom ? 0 : (current?.count ?? 0) + additions,
  };
};
